import config from '@/config'
import { useStore } from '@/utils/store'
import axios from 'axios'
declare global {
  interface Window {
    getToken: any
  }
}

const getHeader = () => {
  return {
    channel: 'STORE_CUSTOMER',
    source: 'STORE_CUSTOMER',
    version: '2021-07-28',
    'Content-Type': 'application/json',
  }
}

export const requests = (host?: string, useAuth: boolean = true, shouldLogout: boolean = true) => {
  const baseUrl = host || config.baseUrl
  const store = useStore()
  const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: getHeader(),
  })

  axiosInstance.interceptors.request.use(async requestConfig => {
    try {
      if (store.token.value && useAuth) requestConfig.headers['Authorization'] = `Bearer ${store.token.value}`
    } catch (e) {
      console.error(e)
    }
    return requestConfig
  })
  axiosInstance.interceptors.response.use(
    response => {
      return response
    },
    error => {
      if (error?.response?.status === 401 && shouldLogout) {
        store.isLogin.value = true
      }
      throw error
    }
  )
  return axiosInstance
}
